// Types
import type { TTextAs, TTextColor, TTextFontType, TTextProps, TTextSize, TTextVariant } from './Text.type';

export const TEXT_AS_LIST: TTextAs[] = ['p', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
export const TEXT_AS: { [key in TTextAs]: TTextAs } = {
  p: 'p',
  span: 'span',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6'
};

export const TEXT_COLORS: TTextColor[] = [
  'primary',
  'secondary',
  'tertiary',
  'success',
  'warning',
  'error',
  'information'
];
export const TEXT_COLOR: { [key in TTextColor]: TTextColor } = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  success: 'success',
  warning: 'warning',
  error: 'error',
  information: 'information'
};

export const TEXT_FONT_TYPES: TTextFontType[] = ['heading', 'body'];
export const TEXT_FONT_TYPE: { [key in TTextFontType]: TTextFontType } = {
  heading: 'heading',
  body: 'body'
};

export const TEXT_SIZES: TTextSize[] = [
  'bodyLarge',
  'bodySmall',
  'captionLarge',
  'captionSmall',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6'
];
export const TEXT_SIZE: { [key in TTextSize]: TTextSize } = {
  bodyLarge: 'bodyLarge',
  bodySmall: 'bodySmall',
  captionLarge: 'captionLarge',
  captionSmall: 'captionSmall',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6'
};

export const TEXT_VARIANTS: TTextVariant[] = ['lowEmphasis', 'medEmphasis', 'highEmphasis'];
export const TEXT_VARIANT: { [key in TTextVariant]: TTextVariant } = {
  lowEmphasis: 'lowEmphasis',
  medEmphasis: 'medEmphasis',
  highEmphasis: 'highEmphasis'
};

export const TEXT_DEFAULT_PROPS: TTextProps = {
  as: TEXT_AS.p,
  fontType: TEXT_FONT_TYPE.body,
  color: TEXT_COLOR.tertiary,
  size: TEXT_SIZE.bodyLarge
  /* Will be used in the future once the the UI is ready */
  // variant: TEXT_VARIANT.medEmphasis,
};
